import { Box } from "theme-ui";
import * as React from 'react';
export default {
  Box,
  React
};